import { Tabs } from 'antd';
import { useNavigate } from 'react-router';
import { PageHeader } from '../../../shared/components/PageHeader';
import { sectionTrail } from '../../../shared/components/section-trail';
import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';
import { AlertRulesTab } from '../components/AlertRulesTab';
import { RaisedAlertsTab } from '../components/RaisedAlertsTab';
import { ALERT_TAB_LABELS, alertTabPath, type AlertTab } from '../alerts.paths';

/** Alerts → what has been raised, and (for those who manage them) the rules that raise it. */
export function AlertsPage({ tab }: { tab: AlertTab }) {
  const navigate = useNavigate();
  const { state } = useCurrentUser();
  const canManageRules = state.status === 'authenticated' && state.user.permissions.includes('alert.manage');
  const items = [
    { key: 'raised', label: ALERT_TAB_LABELS.raised, children: tab === 'raised' && <RaisedAlertsTab /> },
    ...(canManageRules ? [{ key: 'rules', label: ALERT_TAB_LABELS.rules, children: tab === 'rules' && <AlertRulesTab /> }] : []),
  ];

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('alerts')}
        title="Alerts"
        description="Trucks that went quiet, crossed a geofence or sped, and the rules that watch for them."
      />
      <Tabs activeKey={tab} onChange={(key) => navigate(alertTabPath(key as AlertTab))} items={items} />
    </>
  );
}
